var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_3219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 12.45L13.6585 15.1083C13.8266 15.2764 14.0404 15.3604 14.3002 15.3604C14.5599 15.3604 14.7738 15.2764 14.9418 15.1083C15.1099 14.9403 15.1939 14.7264 15.1939 14.4667C15.1939 14.2069 15.1099 13.9931 14.9418 13.825L12.2835 11.1667L14.9418 8.50833C15.1099 8.34028 15.1939 8.12639 15.1939 7.86667C15.1939 7.60694 15.1099 7.39306 14.9418 7.225C14.7738 7.05694 14.5599 6.97292 14.3002 6.97292C14.0404 6.97292 13.8266 7.05694 13.6585 7.225L11.0002 9.88333L8.34183 7.225C8.17377 7.05694 7.95989 6.97292 7.70016 6.97292C7.44044 6.97292 7.22655 7.05694 7.0585 7.225C6.89044 7.39306 6.80641 7.60694 6.80641 7.86667C6.80641 8.12639 6.89044 8.34028 7.0585 8.50833L9.71683 11.1667L7.0585 13.825C6.89044 13.9931 6.80641 14.2069 6.80641 14.4667C6.80641 14.7264 6.89044 14.9403 7.0585 15.1083C7.22655 15.2764 7.44044 15.3604 7.70016 15.3604C7.95989 15.3604 8.17377 15.2764 8.34183 15.1083L11.0002 12.45ZM11.0002 20.3333C9.73211 20.3333 8.54044 20.0927 7.42516 19.6115C6.30989 19.1302 5.33975 18.4771 4.51475 17.6521C3.68975 16.8271 3.03662 15.8569 2.55537 14.7417C2.07412 13.6264 1.8335 12.4347 1.8335 11.1667C1.8335 9.89861 2.07412 8.70694 2.55537 7.59167C3.03662 6.47639 3.68975 5.50625 4.51475 4.68125C5.33975 3.85625 6.30989 3.20313 7.42516 2.72188C8.54044 2.24062 9.73211 2 11.0002 2C12.2682 2 13.4599 2.24062 14.5752 2.72188C15.6904 3.20313 16.6606 3.85625 17.4856 4.68125C18.3106 5.50625 18.9637 6.47639 19.445 7.59167C19.9262 8.70694 20.1668 9.89861 20.1668 11.1667C20.1668 12.4347 19.9262 13.6264 19.445 14.7417C18.9637 15.8569 18.3106 16.8271 17.4856 17.6521C16.6606 18.4771 15.6904 19.1302 14.5752 19.6115C13.4599 20.0927 12.2682 20.3333 11.0002 20.3333Z",
    fill: "#E2E2E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.8305bc6b9222db53bfe48875803a5192.svg";
export { ForwardRef as ReactComponent };